"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.search");

require("core-js/modules/es.string.link");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _Icon = _interopRequireDefault(require("@icare/components/lib/Icon"));

var _Button = _interopRequireDefault(require("@icare/components/lib/Button"));

var _icareLogoColour = _interopRequireDefault(require("@icare/core/statics/icons-social/icare-logo-colour.svg"));

var _UrlUtils = _interopRequireDefault(require("@icare/core/lib/utils/UrlUtils"));

var _ShowLinks = require("../../utils/ShowLinks");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DesktopHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(DesktopHeader, _React$Component);

  var _super = _createSuper(DesktopHeader);

  function DesktopHeader(props) {
    var _this;

    _classCallCheck(this, DesktopHeader);

    _this = _super.call(this, props);
    _this.state = {
      isSearching: false
    };
    return _this;
  }

  _createClass(DesktopHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          header = _this$props.header,
          auth = _this$props.auth,
          title = _this$props.title,
          homePath = _this$props.homePath,
          toggleSearch = _this$props.toggleSearch,
          isSearching = _this$props.isSearching;
      return /*#__PURE__*/_react.default.createElement("header", {
        className: "icare-header"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "l-padding"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "icare-header__content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "icare-header__logo"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: homePath
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _icareLogoColour.default,
        width: 135,
        height: 40,
        alt: "iCare logo"
      })), title && /*#__PURE__*/_react.default.createElement("span", {
        className: "icare-header__title"
      }, title))), header && /*#__PURE__*/_react.default.createElement("nav", null, /*#__PURE__*/_react.default.createElement("ul", {
        className: "icare-header__links"
      }, header.links.map(function (link, i) {
        if (!(0, _ShowLinks.showLink)(auth, link.showAuth)) {
          return;
        } else {
          return /*#__PURE__*/_react.default.createElement("li", {
            key: "".concat(i).concat(link.link, "-header"),
            className: "icare-header__link"
          }, /*#__PURE__*/_react.default.createElement(_Button.default, {
            tag: _UrlUtils.default.isAbsoluteUrl(link.link) ? 'a' : _reactRouterDom.Link,
            href: link.link,
            to: link.link,
            variant: link.icon ? _Button.default.Variant.PRIMARY : _Button.default.Variant.LINK,
            iconName: link.icon,
            iconOnly: !!link.icon,
            target: link.target,
            onClick: function onClick() {
              return link.action;
            }
          }, link.label));
        }
      }), header.search && (0, _ShowLinks.showLink)(auth, header.search.showAuth) && /*#__PURE__*/_react.default.createElement("li", {
        key: "search",
        className: "icare-header__link"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        tag: "button",
        className: "search-toggle",
        variant: _Button.default.Variant.PRIMARY,
        onClick: function onClick() {
          return toggleSearch(!isSearching);
        },
        iconName: isSearching ? 'close-thick' : 'search',
        iconOnly: true
      }, "Toggle search")), header.phone && (0, _ShowLinks.showLink)(auth, header.phone.showAuth) && /*#__PURE__*/_react.default.createElement("li", {
        key: "contact",
        className: "icare-header__link"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: "icare-header__link icare-header__link--phone",
        tag: "a",
        href: "tel:".concat(header.phone.number.replace(/\s/g, '')),
        variant: _Button.default.Variant.LINK,
        key: "contact"
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        iconName: "phone"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "contact-number"
      }, header.phone.number))), header.login && (0, _ShowLinks.showLink)(auth, header.login.showAuth) && /*#__PURE__*/_react.default.createElement("li", {
        key: "login",
        className: "icare-header__link"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        tag: _reactRouterDom.Link,
        to: auth.isAuthenticated ? header.login.logoutPath : header.login.loginPath,
        className: "is-teal is-small",
        key: "logout"
      }, auth.isAuthenticated ? 'Log out' : 'Log in'))))));
    }
  }]);

  return DesktopHeader;
}(_react.default.Component);

exports.default = DesktopHeader;

_defineProperty(DesktopHeader, "propTypes", {
  auth: _propTypes.default.object.isRequired,
  isSearching: _propTypes.default.bool.isRequired,
  toggleSearch: _propTypes.default.func.isRequired,
  homePath: _propTypes.default.string.isRequired,
  header: _propTypes.default.object.isRequired,
  title: _propTypes.default.string.isRequired
});
//# sourceMappingURL=DesktopHeader.js.map